export default __webpack_public_path__ + "static/media/13.b19c5a0c.jpeg";